import { useState } from 'react';
import {
  Typography,
  Box,
  CircularProgress,
  Avatar,
  Container,
  Paper,
} from '@mui/material';
import { useAppDispatch } from '../../../app/store/configureStore';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { verifyEmail } from '../accountSlice';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { LockOutlined } from '@mui/icons-material';

const VerifyEmail = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');
  const token = searchParams.get('token');
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const emailVerification = async () => {
      setIsLoading(true);
      try {
        if (!email || !token) {
          toast.error('Email verification failed.');
          return;
        }
        const passwordResetToken = await dispatch(
          verifyEmail({ email, token })
        ).unwrap();
        if (passwordResetToken) {
          navigate(
            `/account/reset-password?token=${passwordResetToken}&email=${email}`
          );
        }
      } catch (error) {
        console.log(error);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };
    emailVerification();
  }, [email, token]);

  return (
    <Container
      component={Paper}
      maxWidth="sm"
      sx={{
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
        <LockOutlined />
      </Avatar>
      <Typography component="h1" variant="h5">
        {t('account.verify-email.title')}
      </Typography>
      <Box component={Paper} sx={{ p: 4 }}>
        {isLoading ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <CircularProgress />
            <Typography variant="h6" gutterBottom sx={{ mb: 4 }}>
              {t('account.verify-email.loading')}
            </Typography>
          </Box>
        ) : isError ? (
          <Typography variant="h6" color="error">
            {t('account.verify-email.error')}
          </Typography>
        ) : null}
      </Box>
    </Container>
  );
};

export default VerifyEmail;
